export const UPDATE_PUSH_NOTIFICATIONS_SUPPORTED =
  'UPDATE_PUSH_NOTIFICATIONS_SUPPORTED' as const

export const updatePushNotificationsSupportedAction = (value: boolean) => ({
  type: UPDATE_PUSH_NOTIFICATIONS_SUPPORTED,
  value,
})
